<router-outlet></router-outlet>

<ngx-loading [show]="loading" [config]="{ 
    backdropBorderRadius: '3px', 
    primaryColour: loadingColorPrimary,
    secondaryColour: loadingColorSecondary,
    tertiaryColour: loadingColorTertiary,
    fullScreenBackdrop: true }"></ngx-loading>

    <app-custom-message  [model]="messageModel"></app-custom-message>